<template>
  <div
    v-if="!isTemplate"
    class="compare-jobs-toggle"
  >
    <v-btn
      variant="outlined"
      min-width="48"
      width="48"
      class="compare-jobs-icon"
      :active="currentTab === 'compare-jobs'"
      title="Compare Jobs"
      @click="setCurrentTab('compare-jobs')"
    >
      <v-icon icon="$tree-view-thick" />
    </v-btn>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';

const { currentTab } = storeToRefs(useDocumentRightPanel());
const { setCurrentTab } = useDocumentRightPanel();
const { isTemplate } = storeToRefs(useCurrentJobProfile());
</script>

<style lang="less" scoped>
.compare-jobs-icon {
  border-color: @stroke-default;

  :deep(.v-icon) {
    color: @icon-default;
  }

  :deep(svg path) {
    fill: currentColor;
  }
}
</style>
